import { useTranslation } from 'react-i18next'

import { FormModal } from '../../../../../Form'
import { QA_NAME_APPLICANT_CHECKLIST_REJECT_MODAL } from '../ApplicantDocumentChecklist.constants'
import { getApplicantDocumentTypeLabel } from '../ApplicantDocumentChecklist.utils'

import { APPLICANT_DOCUMENT_REJECT_INITIAL_VALUES } from './ApplicantDocumentRejectModal.constants'
import {
  getApplicantDocumentRejectReason,
  getApplicantDocumentRejectValidationSchema,
} from './ApplicantDocumentRejectModal.utils'
import { ApplicantDocumentRejectModalFields } from './ApplicantDocumentRejectModalFields'

function ApplicantDocumentRejectModal({ row, onClose, onSubmit }) {
  const { t } = useTranslation()

  async function handleSubmit({ values }) {
    return onSubmit(getApplicantDocumentRejectReason(values))
  }

  return (
    <FormModal
      Fields={ApplicantDocumentRejectModalFields}
      containerProps={{ qaName: QA_NAME_APPLICANT_CHECKLIST_REJECT_MODAL }}
      formBodyProps={{
        submitButtonText: 'RentalPortal.ApplicantDocumentRejectBtnKey',
      }}
      formFieldsProps={{
        description: t('RentalPortal.ApplicantDocumentRejectTextKey', {
          document: getApplicantDocumentTypeLabel({ row, t }),
        }),
      }}
      formTitle='RentalPortal.ApplicantDocumentRejectModalTitleKey'
      initialValues={APPLICANT_DOCUMENT_REJECT_INITIAL_VALUES}
      validationSchema={getApplicantDocumentRejectValidationSchema(t)}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default ApplicantDocumentRejectModal
